import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ContactService } from 'src/app/services/contact.service';// Adjust the import based on your project structure
import { trigger, transition, style, animate } from '@angular/animations';
import { UserCourseHistoryService } from 'src/app/services/user-course-history.service';


@Component({
  selector: 'app-quiz',
  templateUrl: './quiz.component.html',
  styleUrls: ['./quiz.component.scss'],
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('0.5s ease-out', style({ opacity: 1 }))
      ])
    ])
  ]
})
export class QuizComponent implements OnInit {
  regConfig: any[] = [];
  @Output() onsubmitquiz = new EventEmitter<boolean>();

  @Output() setCourseHistoryFinal = new EventEmitter<boolean>();
  customfield5: any;
  currentQuestion: any;
  currentIndex: number = 0;
  selectedAnswers: { [key: number]: string[] } = {};
  submitted: boolean = false;
  formId: any;
  @Input() quizid: any;
  @Input() productId: any;

  @Input() primaryIndex: any;

  @Input() secondaryIndex: any;

  @Input() courseText: any;

  @Input() courseHistory: any;


  score: number = 0;
  showAnswers: boolean = false;
  showbutton: boolean = true;
  finalScore: any;
  quizCompleted: any=0;
  
  viewAnswers() {
    this.showAnswers = true;
    this.showbutton = false;
  }



  constructor(
    private contactService: ContactService,
    private route: ActivatedRoute,
    private userCourseHistoryService: UserCourseHistoryService
    
  ) { }

  ngOnInit() {

    this.formId = this.route.snapshot.params['id']
    if (this.formId != null) {
      this.createDynamicForm();
    }
    this.createDynamic_Form(this.quizid);

    let courseItemIdIndex = this.courseHistory['userCourseItemHistory'].findIndex(courseItem => courseItem.courseItemId == this.courseText[this.primaryIndex].courseItem[this.secondaryIndex].courseItemId);

    if (courseItemIdIndex > -1) {

    this.finalScore=this.courseHistory.userCourseItemHistory[courseItemIdIndex].quizScore;

    this.quizCompleted=this.courseHistory.userCourseItemHistory[courseItemIdIndex].quizCompleted;

    if(this.finalScore>0&&this.quizCompleted==1){
      
      this.score=this.finalScore

      this.submitted=true;
    }
    }

  }

  init: boolean = false;

  createDynamicForm() {
    this.contactService.getDynmaicForm(this.formId).subscribe((data) => {

      let value: any = data
      console.log(value);
      this.regConfig = value;

      console.log(this.regConfig);
      this.currentQuestion = this.regConfig[this.currentIndex];
      this.init = true;
    });
  }

  createDynamic_Form(id) {
    this.contactService.getDynmaicForm(id).subscribe((data) => {

      let value: any = data
      this.regConfig = value;

      console.log(this.regConfig);
      this.currentQuestion = this.regConfig[this.currentIndex];
      this.init = true;
    });
  }

  selectOption(questionId: number, option: string) {
    this.selectedAnswers[questionId] = [option];
  }

  isOptionSelected(questionId: number, option: string): boolean {
    return this.selectedAnswers[questionId]?.includes(option) || false;
  }

  prevQuestion() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.currentQuestion = this.regConfig[this.currentIndex];
    }
  }

  nextQuestion() {
    if (this.currentIndex < this.regConfig.length - 1) {
      this.currentIndex++;
      this.currentQuestion = this.regConfig[this.currentIndex];
    }
  }

  submitQuiz() {
    this.submitted = true;
    this.calculateScore();

  }
  calculateScore() {
    this.score = 0;
    for (const question of this.regConfig) {
      const userAnswer = this.selectedAnswers[question.fieldId]?.[0];
      if (userAnswer === question.customfield5) {
        this.score++;
      }
    }
  }

  closeResults() {
    this.submitted = false;
  }

  restartQuiz() {
    this.currentIndex = 0;
    this.currentQuestion = this.regConfig[this.currentIndex];
    this.submitted = false;
    this.selectedAnswers = {};
    this.showbutton = true;
    this.showAnswers = false;
  }
  confirmSubmission() {


    this.setCourseHistory();
    alert('Quiz submission confirmed!');
    this.onsubmitquiz.emit(true);
  }

  setCourseHistory() {
    let courseItemId = this.courseText[this.primaryIndex].courseItem[this.secondaryIndex].courseItemId

    let courseId = this.courseText[this.primaryIndex].courseId;

    let courseDuration = 0;

    let courseType = this.courseText[this.primaryIndex].courseItem[this.secondaryIndex].type;

    let object = {

      "courseDuration": courseDuration,
      "courseSpendTime": 0,
      "courseItemLastViewedTime": 0,
      "courseItemId": courseItemId,
      "courseId": courseId,
      "productId": this.productId,
      "quizScore": this.score,
      "quizCompleted": 1,
      "type": courseType

    }

    this.setCourseItem(object)

  }

  setCourseItem(object: any) {

   
      this.userCourseHistoryService.courseHistory(object).subscribe(
        (response) => {
        
       
         this.finalScore=response['data'].userCourseItemHistory[0].quizScore;


        },
        (err) => {
          console.log(err);
        });
   
  }

}
